export default __webpack_public_path__ + "static/media/graphics.c3775c91.png";